import React from "react";

export default class AnywereServices extends React.Component  
{
    constructor(props)    
    {
        super(props);

        const code = this.props.code;
        const place = this.props.place.state !== undefined ? this.props.place.state.name : '';        
        this.place = place;
        this.services = this.props.services.length > 0 ? this.props.services : [];        
        this.ulclass = code !== undefined ? code : '';
    }

    capitalizeFirstLetters = (string) =>
    {
        const data = string.split('-')
        let capitalized = '';

        data.map((word, index) =>
        {
            capitalized += word.charAt(0).toUpperCase() + word.slice(1);
            if(index < data.length-1) capitalized +=' ';
            return true;
        })

        return capitalized;
    }
    
    render()
    {
        return (
            <div className="block popular-services">
                <h2 className="text-center">Find Contractors Anywhere</h2>
                <article className="provider-card card">
                    <ul className={"items-list "+this.ulclass}>
                        {
                            this.services.map((service, index) =>
                            {                               
                                let codename;
                                let servicename = service.n !== null ? service.n.split(',')[0] : '';
                                let servicecode = service.cod !== null ? service.cod : ''
                                let serviceurl = service.url !== null ? service.url : '#';
                                
                                switch(servicecode)
                                {				
                                    case 'residential-demolition':
                                        codename = 'Deck and Fence Removal';
                                        break;

                                    case 'house-demolition':
                                        codename = 'House and Garage Demolition';
                                        break;
                                    
                                    default:	
                                        codename = this.capitalizeFirstLetters(service.cod);
                                        break;
                                }
        
                                return(
                                    <li key={index} className={"item"}>
                                        <a href={'/'+serviceurl}>
                                            <div className="item-text">                                    
                                                <h6>{`${servicename} ${codename}`}</h6>
                                            </div>
                                        </a>
                                    </li>    
                                )
                            })
                        }                   
                        </ul>
                </article>
            </div>)
    }
};